module.exports = __webpack_public_path__ + "static/img/瑋豪企業.a2c5c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/瑋豪企業.png?20181011
// module id = zfKV
// module chunks = 1